import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/analytics/')({
  component: () => (
    <div className="container">
      <div className="flex items-center gap-10">
        <h1 className="mb-8 mr-auto text-2xl font-bold">Analytics</h1>
      </div>
    </div>
  ),
});
